import { ApiService } from '@/service'
import useStore from '@/store/useStore'
import {
  CreditsPurchaseType,
  CreditsPurchaseErrorType,
  PurchaseDataType,
} from '@/types/servicesTypes/walletTypes'
import { showError } from '@/utils/utils'

const { setUserCreditsWallets } = useStore.getState().common

export const updateCreditWallets = async (abortSignal?: AbortSignal) => {
  try {
    const res = await ApiService.getCreditWallets(abortSignal)
    setUserCreditsWallets(res)
    return res
  } catch (e) {
    setUserCreditsWallets([])
  }
}

// TODO: nfts, wallets and credits actions and types should be splitted into separate files
/**
 *
 * @param purchaseData
 * @description this function is used only in PPVPopup/PPVActions component
 */
export const purchaseWithCredits = async (purchaseData: PurchaseDataType) => {
  try {
    const res = await ApiService.purchaseWithCredits(purchaseData)
    const statusCode = (res as CreditsPurchaseErrorType)?.statusCode

    if (statusCode && statusCode >= 400) {
      const error = res as CreditsPurchaseErrorType
      showError(
        `statusCode:${error.statusCode}, title:${error.title}, description:${error.description}`,
      )
      return Promise.reject(res)
    }
    // showSuccess('success')
    return res as CreditsPurchaseType
  } catch (e) {
    return Promise.reject(e)
  }
}
